import { getAuthentication } from '@/hooks/useAuthentication';
import axios from 'axios';

export default async function uploadFile(file: File) {
  let data, error;

  try {
    if (file) {
      const formData = new FormData();
      formData.append('files', file);
      const context = getAuthentication();
      const { data: response } = await axios({
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + context.accessToken,
          'Content-Type': 'multipart/form-data',
        },
        url: `${import.meta.env.VITE_API_URL}/api/upload`,
        data: formData,
      });

      data = response;
    }
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
}
